import { snapDate } from '../core/snapping.js';
import type {
  ConstraintCtx,
  ConstraintResult,
  DragConstraint,
} from '../extensions/index.js';
import type { BarState } from '../extensions/types.js';

/**
 * Snaps the proposed bar state to the active snap grid (`day` / `week`)
 * by delegating to {@link snapDate} — the single source of truth for
 * grid alignment. `none` is a no-op; the constraint always returns
 * `allowed: true` and simply rewrites the proposal.
 */
export class SnapToGridConstraint implements DragConstraint {
  readonly id = 'streamlain.gantt.constraint.snap-to-grid';
  readonly priority = 10;

  validate(proposed: BarState, ctx: ConstraintCtx): ConstraintResult {
    const snapMode = ctx.view.snapMode$.value;
    if (snapMode === 'none') {
      return { allowed: true };
    }

    const startMs = snapDate(proposed.startMs, snapMode);
    const endMs = snapDate(proposed.endMs, snapMode);

    if (startMs === proposed.startMs && endMs === proposed.endMs) {
      return { allowed: true };
    }

    return {
      allowed: true,
      adjustedState: { ...proposed, startMs, endMs },
    };
  }
}
